import { InputBase } from '@mui/material';
import { styled } from '@mui/material/styles';

type StyledInputBaseProps = {
  customWidth?: string | number;
  withoutBorder?: boolean;
};

export const StyledInputBase = styled(InputBase, {
  shouldForwardProp: (prop) =>
    prop !== 'customWidth' && prop !== 'withoutBorder',
})<StyledInputBaseProps>(({ theme, customWidth, withoutBorder }) => ({
  color: 'inherit',
  borderRadius: '32px',
  border: withoutBorder ? 'none' : `1px solid ${theme.palette.secondary.main}`,
  padding: '0 18px',
  background: '#FFF',

  '& .MuiInputBase-input': {
    width: customWidth || '140px',
    padding: '10px 0 10px',
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('md')]: {
      width: customWidth || '94px',
      '&:focus': {
        width: customWidth || '200px',
      },
    },
  },

  '& .Mui-disabled': {
    cursor: 'not-allowed',
  },
}));
